'use es6';

export const PIXELS = 'pixels';
export const PERCENT = 'percent';